import React, { useContext, useEffect, useState } from 'react';
import { Container, CssBaseline } from '@material-ui/core';
import {
  // Redirect,
  Route,
  Switch,
  useHistory,
} from 'react-router-dom';

import Admin from './components/screens/admin';
import AlertDialog3Options from './components/modals/alertDialog3Options';
// import Carer from './components/screens/carer';
import Clinician from './components/screens/clinician';
import Login from './components/screens/login';
import NoMatch from './components/screens/noMatch';
import ResetPassword from './components/screens/resetPassword';
import Patient from './components/screens/patient';
import Technical from './components/screens/technical';
import WrongBrowser from './components/screens/wrongBrowser';

import PrivateRoute from './components/screens/privateRoute';

import { SessionContext } from './utils/context';

import { timeToConsultTokenExpiration, timeToWarn } from './utils/constants_comms';

import translations from './languages/i18n';

import generalStyles from './styles/generalStyles';

function App() {
  const sessionContext = useContext(SessionContext);
  const history = useHistory();

  const classes = generalStyles();

  const [showAlert, setshowAlert] = useState(false);

  const handleExpiredToken = () => {
    setshowAlert(true);
  };

  /* +++++++++++++++++++++++++++++++++++++++ (INICI) Codi per detectar navegador ++++++++++++++++++++++++++++ */
  // Font: https://medium.com/weekly-webtips/here-is-how-you-detect-the-browser-in-use-in-both-javascript-and-css-bcb5a6458379
  const agentHas = (keyword) => navigator.userAgent.toLowerCase().search(keyword.toLowerCase()) > -1;

  const isChrome = () => agentHas('CriOS') || agentHas('Chrome') || !!window.chrome;
  const isFirefox = () => agentHas('Firefox') || agentHas('FxiOS') || agentHas('Focus');
  const isEdge = () => agentHas('Edg');

  const whichBrowser = () => {
    if (isChrome()) return 'Chrome';
    if (isFirefox()) return 'Firefox';
    if (isEdge()) return 'Edge';
    return 'Other';
  };
  const browser = whichBrowser();
  /* +++++++++++++++++++++++++++++++++++++++ (FI) Codi per detectar navegador ++++++++++++++++++++++++++++ */

  window.setInterval(() => {
    if (sessionContext.tokenExp && ((sessionContext.tokenExp * 1000 - Date.now()) < timeToWarn * 60 * 1000)) {
      if (sessionContext.rememberTokenIsNearlyToExpire) {
        const expiredTokenEvent = new Event('expired-token');
        document.dispatchEvent(expiredTokenEvent);
      }
    }
  }, timeToConsultTokenExpiration);

  // Mostram un alert del navegador avisant de que es recarregarà la pàgina i demanant confirmació
  window.onbeforeunload = (event) => {
    const e = event || window.event;
    // Cancel the event
    e.preventDefault();
    if (e) {
      e.returnValue = ''; // Legacy method for cross browser support
    }
    return ''; // Legacy method for cross browser support
  };

  // Miram si s'ha recarregat la pestanya del navegador i, si és així, redirigim a l'usuari a la pantalla inicial (login)
  // ATENCIÓ: la interfície Performance.navigation està deprecated (https://developer.mozilla.org/en-US/docs/Web/API/Performance)
  /* if (window.performance.navigation.type > 0) {
    console.log('hem refrescat');
    // sessionStorage.removeItem('sessionInfo');
    history.replace('/');
  } */
  // La interfície que substitueix a l'anterior és PerformanceNavigationTiming (https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming)
  // Sembla que PerformanceNavigationTiming.type està en mode experimental, pel que podria ser que el codi a continuació deixi de funcionar i s'hagi de modificar:
  const perfEntries = performance.getEntriesByType('navigation');
  if (perfEntries[0].type === 'reload') {
    // L'usuari ha refrescat la pestanya del navegador
    // sessionStorage.removeItem('sessionInfo'); // De moment no borram el token de servidor, de manera que si encara es vàlid feim el login automaticament
    history.replace('/');
  }

  useEffect(() => {
    // Cream el listener
    document.addEventListener('expired-token', handleExpiredToken);
    // És la manera d'eliminar una subscripció al useEffect:
    return () => document.removeEventListener('expired-token', handleExpiredToken);
  }, []);

  const dontRememberExpiration = () => {
    sessionContext.rememberTokenIsNearlyToExpire = false;
    setshowAlert(false);
  };

  const restartSession = () => {
    sessionContext.rememberTokenIsNearlyToExpire = false;
    sessionStorage.removeItem('sessionInfo');
    setshowAlert(false);
    history.replace('/');
  };

  if (browser !== 'Other') {
    return (
      <SessionContext.Provider value={sessionContext}>
        <Container component='main' className={classes.root}>
          <CssBaseline />
          <AlertDialog3Options
            // Anar a login
            button1Text={translations['_restartSession']}
            handleOption1={restartSession}
            // No tornar a recordar
            button2Text={translations['_dontRemember']}
            handleOption2={dontRememberExpiration}
            // Només tancam, en haver passat el temps corresponent es tornarà a mostrar
            handleOption3={() => setshowAlert(false)}
            message={translations['_sessionExpiresShortly']}
            open={showAlert}
            title={translations['_alert']}
          />
          <Switch>
            {/* Component que carregam per defecte */}
            <Route exact path='/'>
              <Login />
            </Route>
            <Route path='/login'>
              <Login />
            </Route>
            <PrivateRoute path='/admin' component={Admin} role='Admin'/>
            <PrivateRoute path='/clinician' component={Clinician} role='Clinician'/>
            <PrivateRoute path='/patient' component={Patient} role='Patient'/>
            <PrivateRoute path='/technical' component={Technical} role='Program_Configuration_User'/>
            {/* <Route path='/carer'>
              <Carer />
            </Route> */}
            {/* PASSWORD RESET */}
            <Route path='/password-reset/:passwordToken'>
              <ResetPassword />
            </Route>
            {/* NO MATCH */}
            <Route path='*'>
              <NoMatch />
              {/* <Redirect to='/' /> // Alternativa a NoMatch, en lloc de mostrar NoMatch va directa a la pantalla d'inici */}
            </Route>
          </Switch>
        </Container>
      </SessionContext.Provider>
    );
  }
  return (
    <Container component='main' className={classes.root}>
      <CssBaseline />
      <WrongBrowser />
    </Container>
  );
}

export default App;
